import { skipToken, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { trpc, useTRPC } from "../../../shared/api/trpc";

export type WorkObjectAuditEvent = Awaited<ReturnType<typeof trpc.workObjects.audit.query>>[number];

export function useWorkObjectAudit(workObjectId: string | null) {
  const trpc = useTRPC();
  const auditQuery = useQuery(trpc.workObjects.audit.queryOptions(workObjectId ? { workObjectId } : skipToken));

  const reload = useCallback(async () => {
    if (workObjectId) await auditQuery.refetch();
  }, [auditQuery.refetch, workObjectId]);

  return {
    data: auditQuery.data ?? [],
    error: auditQuery.error instanceof Error ? auditQuery.error.message : auditQuery.error ? String(auditQuery.error) : null,
    isLoading: auditQuery.isPending,
    reload,
  };
}
